export default "__VITE_ASSET__9x6MAYgy__"